import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/item-page/item-page-data'

import { ItemPageMarkAsReservedButtonPluginModel } from './types'

export const getItemPageMarkAsReservedButtonPluginModel = (
  itemDto: ItemDetailsDto,
): ItemPageMarkAsReservedButtonPluginModel => ({
  itemId: itemDto.id,
  isItemReserved: itemDto.is_reserved,
  canReserve: itemDto.can_reserve,
  transactionPermitted: itemDto.transaction_permitted,
  userId: itemDto.user.id,
})

export const getServerItemPageMarkAsReservedButtonPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
): ItemPageMarkAsReservedButtonPluginModel => ({
  itemId: sidebarDto.id,
  isItemReserved: sidebarDto.is_reserved,
  canReserve: sidebarDto.can_reserve,
  transactionPermitted: sidebarDto.transaction_permitted,
  userId: sidebarDto.seller_id,
})
